export default function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-interpolate/src/quantize.js
// module id = ./node_modules/d3-interpolate/src/quantize.js
// module chunks = vendor